// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3C0M0","description":"PatientConsentPreview_description__3Sohw"};